import { Position } from './types'

interface CalculateDropdownPositionParams {
  triggerRect: DOMRect
  contentRect: DOMRect
  offset: number
  position: Position
}

const SECUTIRY_MARGIN = 8

export function calculateDropdownPosition({
  triggerRect,
  contentRect,
  offset,
  position,
}: CalculateDropdownPositionParams): { top: number; left: number } {
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  let top = 0
  let left = 0

  const positions: Record<Position, () => void> = {
    top: () => {
      top = triggerRect.top - contentRect.height - offset
      left = triggerRect.left
    },
    bottom: () => {
      top = triggerRect.bottom + offset
      left = triggerRect.left
    },
    left: () => {
      top = triggerRect.top
      left = triggerRect.left - contentRect.width - offset
    },
    right: () => {
      top = triggerRect.top
      left = triggerRect.right + offset
    },
  }

  positions[position]()

  if (left + contentRect.width > viewportWidth)
    left = viewportWidth - contentRect.width - SECUTIRY_MARGIN

  if (left < 0) left = SECUTIRY_MARGIN

  if (top + contentRect.height > viewportHeight)
    top = viewportHeight - contentRect.height - SECUTIRY_MARGIN

  if (top < 0) top = SECUTIRY_MARGIN

  return { top, left }
}
